import {
  ArrowLeftOutlined,
  BankOutlined,
  RightOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Avatar,
  Button,
  Card,
  Checkbox,
  Divider,
  Empty,
  PageHeader,
  Typography,
} from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { translation } from "../../../../i18n/translationConstant";
import FIPModel from "../../../../Models/FIPModel";
import { GetFIPRequest } from "../../../../Models/Request/FIP/GetAllFIP";
import { AddIdentifier } from "../../../../Models/Request/Identifier/AddIdentifier";
import AccountLinkConfirmationResponse, {
  AccountLinkConfirmation,
} from "../../../../Models/Response/Account/AccountLink";
import DiscoverAccountResponse, {
  DiscoverAccountObject,
} from "../../../../Models/Response/Account/DiscoverAccount";
import { getFIP } from "../../../../redux/actions";
import store from "../../../../redux/store";
import {
  discoverAccounts,
  linkAccounts,
  linkAccountVerification,
} from "../../../../Services/AccountsServices/AccountService";
import { getFips } from "../../../../Services/FipServices/FipServices";
import { QueryParams, Routes } from "../../../../Utils/Constants/routes";
import LoginSignupSidePanel from "../../../Authentication/Components/Greetings";
import OTPInputComponent from "../../../Common/Components/OTPModal";
import PinInputComponent from "../../../Common/Components/PinInput";
import Identifiers from "../../../Identifiers";
import { RootContext } from "../../../Root";
import EMPTY_STATE from "../../../../Assets/empty_state.png";
import "./index.css";
import CommonModal from "../../../Common/Components/CommonModal";
import { LinkAccountModal } from "../../../../Assets/icons";
import FeedbackModal from "../../../Common/Components/FeedbackModal";
import { InkIcon } from "../../../../Assets/icons";
import { EntityIdentifier } from "../../../../Models/Request/Identifier/EntityIdentifier";

interface ILinkAccountsProps {
  storeFIP: (res: GetFIPRequest) => void;
  fip: FIPModel[];
  fipListToBeShown: FIPModel[];
}

const LinkAccounts: React.FC<ILinkAccountsProps> = ({ storeFIP, fip }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [fipListToBeShown, setFipListToBeShown] = useState(
    new Array<FIPModel>()
  );
  const [fipEntityIdentifiers, setFipEntityIdentifiers] = useState<
    EntityIdentifier[]
  >([]);

  const [currentFip, setCurrentFip] = useState({
    id: "",
    name: "",
    host: "",
    logoUrl: "",
    version: "",
    fipDescription: "",
  });
  const [selectedAccounts, setSelectedAccounts] = useState(new Array<string>());
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [identifiers, setIdentifiers] = useState(new Array<AddIdentifier>());
  const [signature, setSignature] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [step, setStep] = useState(0);
  const [otp, setOtp] = useState("");
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [accountLinked, setAccountedLinked] = useState(false);
  const [visible, setVisibility] = useState(false);
  const [discVisible, setDiscVisibility] = useState(false);

  const [discoverAccountsList, storeDiscoverAccounts] = useState<
    DiscoverAccountObject[]
  >([]);
  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();

  const { setHeaderVisible, setIsMenuBarVisible }: any =
    useContext(RootContext);

  useEffect(() => {
    setFipListToBeShown(fip);
  }, [fip]);

  useEffect(() => {
    setHeaderVisible(false);
    setIsMenuBarVisible(false);
    return () => {
      setIsMenuBarVisible(true);

      setHeaderVisible(true);
    };
  }, [setHeaderVisible, setIsMenuBarVisible]);

  useEffect(() => {
    getFips()
      .then((res) => res.data)
      .then((res: GetFIPRequest) => storeFIP(res));
  }, [storeFIP]);

  const onFIPSelect = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setDiscVisibility(false);
    setCurrentFip(fipListToBeShown[parseInt(event.currentTarget.id, 10)]);
    setFipEntityIdentifiers(
      fipListToBeShown[parseInt(event.currentTarget.id, 10)].entityIdentifier
    );
    setStep(step + 1);
    setFipListToBeShown(fip);
  };

  // useEffect(() => {
  //   console.log(fipEntityIdentifiers);
  // }, [fipEntityIdentifiers]);

  const onAccountsSelect = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    // selectedAccounts.includes(event.currentTarget.id) ? selectedAccounts.re
    if (selectedAccounts.includes(event.currentTarget.id)) {
      setSelectedAccounts(
        selectedAccounts.filter((item) => item !== event.currentTarget.id)
      );
    } else {
      const accounts = [...selectedAccounts];
      accounts.push(event.currentTarget.id);
      setSelectedAccounts(accounts);
    }
  };

  const confirmLinkAccount = () => {
    linkAccounts({
      FipId: currentFip.id,
      Accounts: discoverAccountsList.filter(
        (_account, index) =>
          selectedAccounts.filter((value) => value === index.toString())[0]
      ),
      signature,
    })
      .then((res) => res.data)
      .then((_res: AccountLinkConfirmationResponse) => {
        setIsConfirmModalVisible(false);

        setIsOTPModalVisible(true);
        setRefNumber(_res.refNumber);
      });
  };

  const linkAccount = () => {
    setIsConfirmModalVisible(true);
  };

  const onLinkAccountOtp = () => {
    linkAccountVerification(refNumber, otp, currentFip.id)
      .then((res) => res.data)
      .then((_res: AccountLinkConfirmation) => {
        setIsOTPModalVisible(false);
        setSelectedAccounts([]);
        setCurrentFip({
          id: "",
          name: "",
          host: "",
          logoUrl: "",
          version: "",
          fipDescription: "",
        });

        setAccountedLinked(true);
      });
  };

  const onCancel = () => {
    setIsOTPModalVisible(false);
    setOtp("");
  };

  const setModalVisibility = () => {
    setVisibility(true);
  };

  const setDiscoverVisibility = () => {
    setDiscVisibility(true);
  };

  const closeModalVisibility = () => {
    setVisibility(false);
  };

  const discoverAccountWithIdentifiers = (identifierTem : AddIdentifier[]) => {
    setDiscVisibility(true);
    setStep(step + 1);
    discoverAccounts({
      FITypes: ["GSTR1_3B"],
      FipId: currentFip.id,
      Identifiers: identifierTem,
    })
      .then((res) => res.data)
      .then((res: DiscoverAccountResponse) => {
        storeDiscoverAccounts(res.DiscoveredAccounts);
        setSignature(res.signature);
        setSelectedAccounts([]);
      })
      .catch(() => storeDiscoverAccounts([]));
  };

  const pushToAccount = () => {
    history.push(Routes.account);
  };

  const onSearchValueChange = (value: string) => {
    setFipListToBeShown(
      value
        ? fip.filter(
            (p) => p.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
          )
        : fip
    );
  };

  const goBack = () => {
    if (step === 0) {
      history.push(Routes.account);
    } else {
      setDiscVisibility(false);
      setStep(step - 1);
      setSelectedAccounts([]);
      storeDiscoverAccounts([]);
    }
  };

  const onRadioSelect = (e: any) => {
    setIdentifiers(e);
  };

  const memoizedCallback = useCallback(onRadioSelect, []);

  const linkAccountSuccess = () => {
    if (query && query.get(QueryParams.redirect)) {
      history.goBack();
    } else {
      history.push(Routes.account);
    }
  };

  const renderStep = () => {
    return step === 0 ? (
      // THIS is LIST OF FIP SCREEN
      <div className="fipListScreen">
        {/* <Typography.Text className="linkAccountToAATypo">
          {t("Link your bank account to INK-AA")}
        </Typography.Text> */}
        <div className="fipCardList">
          <div className="fipListContainer ">
            {fipListToBeShown &&
              fipListToBeShown.map((FIP: FIPModel, index) => (
                <div className="fipListItem" key={index}>
                  <Card
                    key={index}
                    className="linkAccountCard"
                    id={index.toString()}
                    hoverable={false}
                    onClick={
                      FIP.fipDescription != "Coming Soon"
                        ? onFIPSelect
                        : undefined
                    }
                    // onClick={onFIPSelect}
                    bordered={false}
                  >
                    {FIP.logoUrl != "" ? (
                      <div className="fipLogo">
                        <img src={FIP.logoUrl} alt="" />
                      </div>
                    ) : (
                      <div className="fipLogo">
                        {/* <BankOutlined style={{ fontSize: "2.5em", alignContent: 'center', alignItems: 'center' }} /> */}
                      </div>
                    )}
                    <div className="cardContent">
                      <Typography.Text className="cardContentFIPTitle">
                        {FIP.name}
                      </Typography.Text>
                      <Typography.Text className="cardContentFIPSubTitle">
                        {FIP.fipDescription}
                      </Typography.Text>
                    </div>
                    <RightOutlined className="checkOutlined" onPointerOverCapture={undefined} onPointerMoveCapture={undefined} />
                  </Card>
                  <Divider className="accountDivider" />
                </div>
              ))}
          </div>
        </div>

        <Button
          type="text"
          className="commonButtonBackground skipButton"
          // style={{ fontSize: 20}}
          onClick={pushToAccount}
        >
          {t(translation.lblSkip)}
        </Button>
      </div>
    ) : (
      // THIS IS FIP DETAILS SCREEN
      <>
        <Typography.Text className="fontSize18FontWeight500">
          {t(translation.lblIdentifiersFirst)}{" "}
          <Typography.Text className="moreItemIcons fontSize18FontWeight500">
            {currentFip.name}
          </Typography.Text>{" "}
          {t(translation.accounts)}{" "}
          <Typography.Text className="fipDescriptionDiv fontSize18FontWeight500">
            {currentFip.fipDescription}{" "}
          </Typography.Text>
        </Typography.Text>

        <div className="linkAccountFipDetailBody">
          {/* 
          Below Identifiers Widget contains list of Identifiers
          as well as Add Identifier and Discover Accounts Button
        */}
          {!discVisible ? (
            <Identifiers //TODO data persistant for all 3 steps
              onRadioSelect={memoizedCallback}
              onSelectIdentifier={discoverAccountWithIdentifiers}
              modalVisibility={visible}
              fipEntityIdentifiers={fipEntityIdentifiers}
              onCloseModal={closeModalVisibility}
            />
          ) : /* {<Divider  className="vertical-divider" /> }*/
          /* {<span className="vertical-divider"> </span> }*/

          discoverAccountsList && discoverAccountsList.length ? (
            <div className="linkAccountBody">
              <div className="discoverAccounts">
                {discoverAccountsList && discoverAccountsList.length ? (
                  discoverAccountsList.map((accounts, index) => (
                    <Card
                      key={index}
                      className="discoverAccountCard"
                      id={index.toString()}
                      hoverable={false}
                      onClick={onAccountsSelect}
                    >
                      <Avatar
                        className="consentAvatar"
                        src={currentFip.logoUrl}
                      />
                      <div className="accountInfo">
                        <Typography.Text className="accountCardFIP">
                          {currentFip && currentFip.name}
                        </Typography.Text>
                        <br />
                        <div>
                          <Typography.Text className="accountCardNumber">
                            {accounts.maskedAccNumber}
                          </Typography.Text>
                          <Divider type="vertical" />
                          <Typography.Text className="accountCardAccountType">
                            {accounts.accType}
                          </Typography.Text>
                          <Divider type="vertical" />
                          <Typography.Text className="accountCardAccountType">
                            {accounts.FIType}
                          </Typography.Text>
                        </div>
                      </div>

                      <Checkbox
                        checked={selectedAccounts.includes(index.toString())}
                        className="checkBoxAccount"
                      />
                    </Card>
                  ))
                ) : (
                  <Empty
                    className="emptyTag"
                    image={EMPTY_STATE}
                    description={
                      <Typography.Text className="noAccountFound">
                        {t(translation.errorNoAccountsFound)}
                      </Typography.Text>
                    }
                  />
                )}
              </div>
              <div className="linkAccountButton">
                <Button
                  disabled={selectedAccounts.length ? false : true}
                  className="commonButtonBackground primaryButton linkAccountNoAccounts"
                  onClick={linkAccount}
                >
                  {t(translation.lblLinkAccount)}
                </Button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <OTPInputComponent
        onCancel={onCancel}
        isOpen={isOTPModalVisible}
        onOtpSubmit={onLinkAccountOtp}
        okText={t(translation.lblConfirm)}
        numInputs={6}
        title={t(translation.lblLinkAccount)}
        onResend={linkAccount}
        isOtpInputVisible={true}
        mobileNumber={
          identifiers
            .filter(
              (value) =>
                value.categoryType === "STRONG" && value.type === "MOBILE"
            )
            .map((value) => value.value)[0]
        }
      >
        <PinInputComponent
          className="pinInput"
          // tslint:disable-next-line: jsx-no-lambda
          onChange={(pin) => setOtp(pin)}
          maxLength={10}
          enterPressed={onLinkAccountOtp}
          label={t(translation.lblEnterOTP)}
        />
      </OTPInputComponent>

      <CommonModal
        onCancel={() => setIsConfirmModalVisible(false)}
        visible={isConfirmModalVisible}
      >
        <div className="col alignCenter">
          <LinkAccountModal className="marginTop20" />
          <Typography.Text className="font24 fontWeight600 marginTop10">
            {t("lblLinkAccounts")}
          </Typography.Text>
          <Typography.Text className="font16 fontWeight500 marginTop10">
            {t("msgLinkedAccounts")}
          </Typography.Text>

          <div className="modalButtonGroup">
            <Button
              className="commonButtonBackground secondaryButton width40Pmargintop0"
              onClick={() => setIsConfirmModalVisible(false)}
            >
              {t(translation.lblCancel)}
            </Button>

            <Button
              className="commonButtonBackground primaryButton linkAccountNoAccounts primaryButtonWidth"
              onClick={confirmLinkAccount}
            >
              {t(translation.lblLinkAccounts)}
            </Button>
          </div>
        </div>
      </CommonModal>

      {accountLinked ? (
        <FeedbackModal
          modalClose={linkAccountSuccess}
          message={t("OTP verified successfully")}
          action={linkAccountSuccess}
          actionButtonText={t("lblContinue")}
        ></FeedbackModal>
      ) : (
        <></>
      )}
      {/* 
          Below layout is for LINK ACCOUNT PAGE
          ~ Aryan
      */}
      <div className="linkAccountContainer">
        <div className="sliderCss subPanelBorder">
          {/* Commenting side panel below */}
          {/* <LoginSignupSidePanel type="linkAccount" /> */}
          <div className="linkAccountSignForm flexCustomCss linkAccountRoot">
            <div className="linkAccountHeader">
              <PageHeader
                className="linkAccountTitle"
                backIcon={<ArrowLeftOutlined className="backIcon" onPointerOverCapture={undefined} onPointerMoveCapture={undefined} />}
                onBack={goBack}
                title={t(translation.lblLinkAccount)}
                // subTitle={step === 1 ? t(currentFip.fipDescription) : null}
                // avatar={{
                //   icon: (
                //     <InkIcon
                //       height={32}
                //       width={35}
                //       style={{ backgroundColor: "white" }}
                //     />
                //   ),
                // }}
                extra={
                  step === 1 && (
                    // <AutoComplete
                    //   className="autcomplete"
                    //   allowClear={true}
                    //   autoFocus={true}
                    //   open={false}
                    //   autoClearSearchValue={true}
                    //   placeholder={t(translation.lblHomeSearch)}
                    //   onChange={onSearchValueChange}
                    //   size="large"
                    // />
                    <Button
                      className="commonButtonBackground linkAccountNoAccounts primaryButton "
                      onClick={setModalVisibility}
                    >
                      {t(translation.lblAddIdentifier)}
                    </Button>
                  )
                }
              />
            </div>
            {step === 0 && (
              <AutoComplete
                className="autcomplete"
                allowClear={true}
                autoFocus={true}
                open={false}
                autoClearSearchValue={true}
                placeholder={t(translation.lblHomeSearch)}
                onChange={onSearchValueChange}
                size="large"
              />
            )}
            {renderStep()}
          </div>
        </div>
      </div>
    </>
  );
};

const storeFip = (res: GetFIPRequest) => store.dispatch(getFIP(res));

const mapDispatchToProps = () => {
  return {
    storeFIP: storeFip,
  };
};

const mapStateToProps = (state: any) => ({
  fip: state.fip.fips,
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkAccounts);
